import { Component, Input } from '@angular/core';
import { MessageService } from '../../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../../shared/services/integrations/shootProof/shootProof.data.service';
import { InvoicesDataProvider } from '../../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { UtilsServiceProvider } from '../../../../../../../shared/services/utils/utils-service';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { DeleteConfirmationModal } from '@web-components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal';
import { PickTimeDataProvider } from '@services/integrations/pickTime/pickTime.data.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { IntegrationsServiceProvider } from '@services/integrations/integrations.service';

@Component({
	selector: 'delete-gallery-modal',
	template: require('./delete-gallery.modal.html'),
	styles: [require('./delete-gallery.modal.scss')]
})
export class DeleteGalleryModal {
	@Input('deleteGalleryId') deleteGalleryId: number;
	@Input('picTimeActions') picTimeActions;
	@Input('actions')
	set actions(value) {
		this.checkAvailableActions(value);
		this._actions = value;
	}

	get actions() {
		return this._actions;
	}
	buttonsDisable = false;
	deleteGalleryFromSNSpinner = false;
	_actions;
	showDeleteFromSNBtn = true;
	showDeleteFromSPBtn = true;
	deleteConfirmationModalRef: NgbModalRef;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private pickTimeDataProvider: PickTimeDataProvider,
		private messageService: MessageService,
		private invoiceDataService: InvoicesDataProvider,
		private utilService: UtilsServiceProvider,
		private activeModal: NgbActiveModal,
		private modalService: SNModalService,
		private integrationService: IntegrationsServiceProvider
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	dismiss() {
		this.activeModal.close(false);
		this.removeSpinners();
	}

	deleteGalleryFromSN() {
		this.deleteGalleryFromSNSpinner = true;
		this.deleteGallery();
	}

	openDeleteConfirmationModal() {
		this.activeModal.close();
		this.deleteConfirmationModalRef = this.modalService.openModal(
			DeleteConfirmationModal,
			{
				windowClass: 'ng-bootstrap-modal__small gallery-delete-modal'
			}
		);
		this.deleteConfirmationModalRef.componentInstance.deleteGalleryId = this.deleteGalleryId;
		this.deleteConfirmationModalRef.result.then(() => {
			this.updateGalleriesEvent();
		});
	}

	deletePicTimeGallery(): void {
		this.buttonsDisable = true;
		this.deleteGalleryFromSNSpinner = true;
		const url = this.picTimeActions.DELETE_GALLERY.url;
		this.pickTimeDataProvider
			.deletePicTimeGallery(url)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize(() => this.removeSpinners())
			)
			.subscribe(
				(): void => this.successDeletePicTimeGallery(),
				error => this.messageService.handleError(error)
			);
	}

	private checkAvailableActions(actions) {
		if (actions && actions !== null) {
			this.showDeleteFromSNBtn =
				actions.hasOwnProperty('DELETE_FROM_SN') &&
				actions.DELETE_FROM_SN.state === 'active';
			this.showDeleteFromSPBtn =
				actions.hasOwnProperty('DELETE_FROM_SP') &&
				actions.DELETE_FROM_SP.state === 'active';
		} else {
			this.showDeleteFromSNBtn = false;
			this.showDeleteFromSPBtn = false;
		}
	}

	private deleteGallery(): void {
		this.buttonsDisable = true;
		this.shootProofDataService
			.removeJobGalleryV1(this.deleteGalleryId, false)
			.pipe(finalize((): void => this.removeSpinners()))
			.subscribe(
				(): void => this.successDeleteShootProofGallery(),
				(error): void => this.messageService.handleError(error)
			);
	}

	private removeSpinners() {
		this.buttonsDisable = false;
		this.deleteGalleryFromSNSpinner = false;
	}

	private successDeleteShootProofGallery() {
		this.updateGalleriesEvent();
		this.messageService.showToaster('s_5', 'shootProof');
		this.dismiss();
	}

	private successDeletePicTimeGallery() {
		this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_PT_INVOICES');
		this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
		this.messageService.showToaster('s_4', 'picTime');
		this.dismiss();
	}

	private updateGalleriesEvent() {
		this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_SP_INVOICES');
		this.integrationService.emitGalleriesUpdateEvent('UPDATE_SN_GALLERIES');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.ts